import { render, staticRenderFns } from "./mensageria-list.vue?vue&type=template&id=16cb0d1a"
import script from "./mensageria-list.vue?vue&type=script&lang=js"
export * from "./mensageria-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports